<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage" id="calibre_pb_0">
<span id="id-93107411740218013"></span>
<div class="ph">THE HARDY BOYS</div>
<h1 class="sigil_not_in_toc" id="pgepubid00000">THE HOUSE
ON THE CLIFF</h1>
<div class="ph">By FRANKLIN W. DIXON</div>
</div>
<div class="figcenter" id="frontis">
<img alt="" class="w" id="id-5733789868116482082" src="OEBPS/Images/557129876733097726_frontis.jpg"/>
<div class="caption" id="ebm_caption0">“WE’VE FOUND THE PASSAGE!” (Chapter XVII)</div>
</div>
<hr class="chap"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section00.vue?0264c978